import React from 'react';
import { Zap, Wallet, LineChart, FileCheck, Building2, Lightbulb } from 'lucide-react';

const services = [
  {
    icon: Zap,
    title: 'Consulenza Energetica',
    description: 'Analisi approfondita dei consumi e ottimizzazione delle forniture energetiche per massimizzare l\'efficienza.',
    color: '#5CBDB0',
    features: [
      'Audit energetico e confronto tariffe',
      'Verifica agevolazioni fiscali POD/PDR per codici ATECO',
      'Recupero importi pagati erroneamente (soprattutto gas)',
      'Installazione fotovoltaici per aziende e domestici',
      'Creazione contatori BT e MT per qualunque attività'
    ]
  },
  {
    icon: Wallet,
    title: 'Finanza Agevolata',
    description: 'Accesso a bandi, incentivi e finanziamenti per investimenti in efficienza energetica e sostenibilità.',
    color: '#F5A547',
    features: ['Bandi regionali e locali', 'Credito d\'imposta', 'Fondi europei', 'Bandi Agrivoltaico', 'Bandi Agrisolare']
  },
  {
    icon: LineChart,
    title: 'Monitoraggio Consumi',
    description: 'Sistemi di monitoraggio in tempo reale per identificare sprechi e opportunità di risparmio.',
    color: '#C14B7E',
    features: ['Dashboard dedicata', 'Alert automatici', 'Report mensili']
  },
  {
    icon: FileCheck,
    title: 'Pratiche Autorizzative',
    description: 'Gestione completa delle pratiche burocratiche per impianti fotovoltaici e interventi di efficientamento.',
    color: '#5CBDB0',
    features: ['Permessi GSE', 'Connessione rete', 'Incentivi conto energia', 'Recupero incentivi GSE calcolati erroneamente']
  },
  {
    icon: Building2,
    title: 'Soluzioni per Industrie',
    description: 'Progetti su misura per aziende energivore con focus su riduzione costi e impatto ambientale.',
    color: '#F5A547',
    features: ['Cogenerazione', 'Power Purchase Agreement', 'Comunità energetiche']
  },
  {
    icon: Lightbulb,
    title: 'Transizione Ecologica',
    description: 'Accompagnamento nel percorso verso la sostenibilità con soluzioni concrete e misurabili.',
    color: '#C14B7E',
    features: ['Carbon footprint', 'Certificazioni green', 'ESG reporting']
  }
];

const Services = () => {
  return (
    <section id="servizi" data-testid="services-section" className="py-24 md:py-32 relative">
      {/* Background accent */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-[#5CBDB0]/5 rounded-full blur-3xl -translate-y-1/2" />
      
      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-left mb-16 md:mb-20">
          <span className="text-sm uppercase tracking-widest font-bold text-[#5CBDB0] mb-4 block">
            I Nostri Servizi
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-white mb-6">
            Soluzioni Complete per la
            <br />
            <span className="gradient-text">Gestione Energetica</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg max-w-2xl">
            Un approccio integrato che combina consulenza strategica, accesso ai finanziamenti 
            e soluzioni tecnologiche per trasformare l'energia in un asset competitivo.
          </p>
        </div>

        {/* Services Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="service-card group bg-[#151e32] rounded-2xl p-8 border border-white/5"
              data-testid={`service-card-${index}`}
            >
              {/* Icon */}
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110"
                style={{ backgroundColor: `${service.color}20` }}
              >
                <service.icon 
                  className="w-7 h-7" 
                  style={{ color: service.color }} 
                />
              </div>

              {/* Content */}
              <h3 className="font-heading text-xl font-semibold text-white mb-3">
                {service.title}
              </h3>
              <p className="text-white/50 text-sm leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-white/40">
                    <div 
                      className="w-1.5 h-1.5 rounded-full"
                      style={{ backgroundColor: service.color }}
                    />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-white/50 mb-6">
            Non trovi quello che cerchi? Contattaci per una soluzione personalizzata.
          </p>
          <a
            href="#contatti"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contatti')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-secondary inline-flex items-center gap-2 border border-[#5CBDB0] text-[#5CBDB0] px-8 py-3 rounded-full font-semibold"
            data-testid="services-cta-button"
          >
            Parliamo del Tuo Progetto
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
